export const SET_COUNTRY = 'SET_COUNTRY';